import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// Rxjs
import { of, from } from 'rxjs';
import {
  switchMap,
  map,
  catchError,
  withLatestFrom,
  take,
  tap,
  delay,
  mergeMap,
  concatMap,
} from 'rxjs/operators';
// Store
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../app.state';
// Actions
import {
  loadValuesList,
  loadValuesListSuccess,
  loadValuesListFailure,
  getSelectedValue,
  getSelectedValueSuccess,
  getSelectedValueFailure,  
} from '../actions/value.actions';

// Models

// Services
import { ValueService } from '../../services/value.service';

@Injectable()
export class ValueEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private router: Router,
    private valueService: ValueService,
    private toastAlert: ToastrService
  ) {}

  loadValuesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadValuesList),
      //withLatestFrom(this.store.select(selectValue)),
      concatMap(({ formId, versionId }) =>
        this.valueService.getValues(formId, versionId).pipe(
          //tap((data:any) => {console.log('EFFECT loadValuesList->', data)}),
          map((data: any) => loadValuesListSuccess({ data: data })),
          catchError((error) => of(loadValuesListFailure({ error })))
        )
      )
    )
  );

  getSelectedValue$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getSelectedValue),
      concatMap(({ formId, versionId, value }) =>
        this.valueService.getValue(formId, versionId, value).pipe(
          map((data: any) => getSelectedValueSuccess({ value: data })),
          catchError((error) => of(getSelectedValueFailure({ error })))
        )
      )
    )
  );

  ValuesError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          loadValuesListFailure,
          getSelectedValueFailure
        ),
        tap(({ error }) => {
          const msgError = error.error || 'Internal Error ';
          this.toastAlert.error(msgError, 'Error');
        })
      ),
    { dispatch: false }
  );
}
